<template>
  <CCard>
    <CCardHeader>
      {{ $t("Files List") }}
    </CCardHeader>
    <CCardBody>
      <table-component
        :url="CAMPAIGNS_ENDPOINTS.all_files"
        ref="filesTable"
        :columns="Object.keys(tableHeadings)"
        :filterExcludeColumns="['actions']"
        :sortExcludeColumns="['actions']"
        :tableDateFormat="$options.dateFormat"
        :headings="tableHeadings"
        defaultOrderBy="-date_integration"
      >
        <template #actions="{ row }">
          <CButton
            @click="
              () =>
                $downloadFile({
                  url: CAMPAIGNS_ENDPOINTS.download_csv(row.id_campaign)
                })
            "
            color="primary"
            variant="outline"
            v-c-tooltip="`${$t('Download file')}`"
          >
            <i class="mz-icon icon-download-alt color-inherit" />
          </CButton>
        </template>
        <template #line_count="{ row }">
          {{ $getNumericalValue(row.line_count, 0) }}
        </template>
        <template #id_campaign="{ row }">
          {{ row.id_campaign }}
        </template>
      </table-component>
    </CCardBody>
  </CCard>
</template>

<script>
import { CAMPAIGNS_ENDPOINTS } from "@/services/campaigns";
import AddButton from "@/components/AddButton";
import { RISK_FILES_ENDPOINTS } from "@/services/risk_files";

export default {
  name: "FileList",
  components: { AddButton },
  data() {
    return {
      existingFiles: [],
      CAMPAIGNS_ENDPOINTS,
      RISK_FILES_ENDPOINTS,
      tableHeadings: {
        date_end: this.$t("Closure Date"),
        id_campaign: this.$t("Campaign"),
        line_count: this.$t("Lines"),
        actions: "",
      }
    };
  }
};
</script>
